import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {BranchTransaction, IBranchTransaction} from 'app/blocks/model/branch-transaction.model';
import {BranchTransactionService} from 'app/blocks/service/api/branch-transaction.service';

@Injectable({
    providedIn: 'root'
})
export class BranchTransactionResource extends AbstractEntityResource<IBranchTransaction> {
    constructor(branchTransactionService: BranchTransactionService, router: Router) {
        super(
            Resource.BRANCH_TRANSACTIONS,
            branchTransactionService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.BRANCH_TRANSACTIONS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.BRANCH_TRANSACTIONS),
            (entity?) => new BranchTransaction(entity),
            (entity) => entity.id,
            'share'
        );
    }
}
